import styled from "styled-components";

export const UploadContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border: 1px dashed #abb4f4;
  border-radius: 8px;
  background-color: #dce0fc;
  cursor: pointer;
  text-align: center;
  color: #4056f4;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: #cdd2f3;
  }
`;

export const DragArea = styled(UploadContainer)`
  background-color: ${(props) => (props.dragging ? "#cdd2f3" : "#e4e7fc")};
`;
